import { render, staticRenderFns } from "./SaveDetails.vue?vue&type=template&id=63ddf8fb&scoped=true"
import script from "./SaveDetails.vue?vue&type=script&lang=js"
export * from "./SaveDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ddf8fb",
  null
  
)

export default component.exports